import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateClientFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.clientsUpdateFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.clientsFilters]);
    },
  });
};
